import MarkdownContent from 'src/features/product/product-detail/ui/updates-tab/markdown-content/MarkdownContent';

interface RfqChatReceivedProps {
  text: string;
  onSignalDetected?: (signal: string) => void;
  onFinishChat?: () => void;
}

const RfqChatReceived = ({
  text,
  onSignalDetected,
  onFinishChat
}: RfqChatReceivedProps) => {
  return (
    <div className="flex justify-start">
      <MarkdownContent
        wrapperClassName="gap-2"
        markdownString={text}
        onSignalDetected={onSignalDetected}
        onDone={onFinishChat}
      />
    </div>
  );
};

export default RfqChatReceived;
